import { render } from "./ReaLName.vue?vue&type=template&id=2182d8cc&scoped=true&ts=true&lang=pug"
import script from "./ReaLName.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReaLName.vue?vue&type=script&lang=ts&setup=true"

import "./ReaLName.vue?vue&type=style&index=0&id=2182d8cc&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2182d8cc"]])

export default __exports__